import React, { useEffect, useState } from 'react'
import { Container, Input, FormGroup, Label } from 'reactstrap'
import AddCompany from './AddCompany'
import UpdateViewCompany from './UpdateViewCompany'
import TableRoot from './tables/TableRoot'
import Shimmer from 'commonComponents/Shimmer'
import { useDispatch, useSelector } from 'react-redux'
import { fetchCompanyById, fetchCompanyList } from './redux/dispatcher'
import apiEndpoints from 'utils/apiList'
import DeleteModel from 'commonComponents/DeleteModel'
import { fetchFluidHandlerList } from 'commonRedux/getFluidHandler/dispatcher'
import { fetchCompanyAdminList } from 'commonRedux/getCompanyAdmin/dispatcher'
import useDebouncedEffect from 'commonComponents/DeboucedEffect'


function Index({ }) {
    const dispatch = useDispatch();
    const companyList = useSelector((state)=> state.companyListReducer) || [];

    const [searchQuery, setSearchQuery] = useState('')
    const [isUpdate, setIsUpdate] = useState(false)
    const [isViewOnly, setIsViewOnly] = useState(false);
    const [singleCompanyData, setSingleCompanyData] = useState(companyList?.selectedCompany);
    const [currentPage, setCurrentPage] = useState(companyList?.data?.pagination?.currentPage || 1);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [deleteItemId, setDeleteItemId] = useState('')
    const [isShimmer, setIsShimmer] = useState(companyList.isLoading)
    const [isDelete, setIsDelete] = useState(false)
    const [isAddModalShow, setIsAddModalShow] = useState(false);
    const [totalPages, setTotalPages] = useState(companyList?.data?.pagination?.totalPages  || 1);
   
    useEffect(()=>{
        setTotalPages(companyList?.data?.pagination?.totalPages  || 1)
        setCurrentPage(companyList?.data?.pagination?.currentPage || 1)
    }, [companyList?.data?.pagination?.totalPages ]);

    useEffect(()=>{
        setCurrentPage(companyList?.data?.pagination?.currentPage || 1)
    }, [companyList?.data?.pagination?.currentPage])
    useEffect(()=>{
        dispatch(fetchCompanyList({ searchQuery:'',  currentPage, rowsPerPage }));
        
    }, [dispatch, currentPage]);

    useDebouncedEffect(() => {
        dispatch(fetchCompanyList({ searchQuery,  currentPage, rowsPerPage }));
    }, [searchQuery, rowsPerPage], 1000); 

    useEffect(() => {
        if (companyList?.selectedCompany) {
            setSingleCompanyData(companyList.selectedCompany);
        }
    }, [companyList?.selectedCompany]);


    useEffect(()=>{
        const fetchData = async () => {
            setIsAddModalShow(false)
            try {
                await Promise.all([
                    dispatch(fetchCompanyAdminList()),
                    dispatch(fetchFluidHandlerList())
                ]);
                // Code to run after both API calls have completed
                setIsAddModalShow(false)
            } catch (error) {
                // Handle errors if needed
                console.error('Error fetching data:', error);
                setIsAddModalShow(false)

            }
        };

        fetchData();
    }, []);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleSearchChange = (event) => {
        const value = event.target.value;
        setSearchQuery(value);
    }

    const handleEdit = (id) => {
        dispatch(fetchCompanyById(id, setIsUpdate))
        // setIsUpdate(!isUpdate)

    }

    const handleDelete = (id) => {
        setDeleteItemId(id)
        setIsDelete(true);
    }

    const handleView = (id) => {
        dispatch(fetchCompanyById(id, setIsViewOnly))
    }
    const tableData = companyList?.data?.data || [];

    return (
        <>
            <div className="col-12 d-flex justify-content-end stickyFilter">
                <Container fluid>
                    <div className="d-flex flex-row justify-content-end mt-4 mb-3">
                    <FormGroup className="mr-3">
                        <Label for="searchInput" hidden>Search</Label>
                        <div style={{ position: 'relative', width: "230px", display: 'inline-block' }}>
                          <Input
                              type="text"
                              id="searchInput"
                              value={searchQuery}
                              onChange={(e)=>{
                                  handleSearchChange(e)
                                  setCurrentPage(1)
                              }}
                              placeholder="Search by Company Name"
                              style={{ width: "100%", paddingRight: "30px" }}
                          />
                          {searchQuery && (
                            <i
                              className="fa-solid fa-xmark"
                              style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#6c757d' }}
                              onClick={() => {
                                setSearchQuery("");
                                setCurrentPage(1);
                              }}
                            ></i>
                          )}
                        </div>
                    </FormGroup>
                    <div>
                        {
                            isUpdate || isViewOnly ?
                                <UpdateViewCompany
                                    isViewOnly={isViewOnly}
                                    setIsUpdate={setIsUpdate}
                                    setIsViewOnly={setIsViewOnly}
                                    data={singleCompanyData}
                                    searchQuery={searchQuery}
                                />
                                :  <AddCompany />
                        }
                        
                                {isDelete && <DeleteModel setIsDelete={setIsDelete} id={deleteItemId} apiEndpoint={apiEndpoints.COMPANY_DELETE} flagName = {'machineList'}/>}
                    </div>
                    </div>
                </Container>
            </div>

            <div>
                {
                    isShimmer ? <Shimmer /> :

                        <TableRoot
                            header={['Sr. No.', 'Company Name', 'Region', 'Company Admin', 'Contact Person', 'Contact Person Number', 'Subscription Valid Upto', 'Water Cost',  'Status', 'Action']}
                            tableData={tableData}
                            handleEdit={handleEdit}
                            handleDelete={handleDelete}
                            handleView={handleView}
                            currentPage={currentPage}
                            totalPages={totalPages}
                            handlePageChange={handlePageChange}
                            rowsPerPage={rowsPerPage}
                            setRowsPerPage={setRowsPerPage}
                        />
                }
            </div>
        </>
    )
}

export default Index
